import RemindMessage from '@kopapro/components/commons/remindMessage/remindMessage';

export default RemindMessage;
